<footer class="footer flex-center flex-col text-white">
  <h2 class="font-x3l mb-2">Rental Car</h2>
  <div class="flex-center flex-col text-center">
    <p>
      Developed by
      <app-text-link
        [text]="'Pablo Kazalukian'"
        [routerLink]="'https://github.com/PabloKazalukian/Rental-Car'"
        [color]="'primary'"
        [isExternal]="true"
      ></app-text-link>

      | Full-Stack-Developer
    </p>
  </div>
</footer>
